const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { multiTenant: true }]
}

export default conditions
